import React from 'react'
import './EventNavigation.css'
export default function EventNavigation(props) {
  return (
    <div className='EventNavigation'>
        this is a event
    </div>
  )
}
